export default __webpack_public_path__ + "static/media/EventIconClicked.2fd8c8eb.svg";